__turbopack_context__.v({
  "closeButton": "header-module__xtO7-q__closeButton",
  "copyrightContainer": "header-module__xtO7-q__copyrightContainer",
  "header": "header-module__xtO7-q__header",
  "menuContainer": "header-module__xtO7-q__menuContainer",
  "menuItem": "header-module__xtO7-q__menuItem",
  "navRight": "header-module__xtO7-q__navRight",
});
